import React from 'react';
import { useMessage } from '@tmapy/intl';

import '../../app/components/Badge.scss';

import { Badge, DangerBadge, Icon, InfoBadge, SuccessBadge, SvgSpinner } from '@tmapy/style-guide';

import { EPSI_STATE } from './constants';
import { epsiStateMessages } from './epsiMessages';

type EpsiBadgeProps = {
  state: EPSI_STATE;
};

/**
 * Stav dne PSPI evidence. Průběžné stavy (stahuje se / importuje se) mají
 * spinner — stahování legitimně trvá i hodiny, takže to není indikace problému.
 */
export const EpsiBadge: React.FC<EpsiBadgeProps> = ({ state }) => {
  const formatMessage = useMessage();

  const stateText = formatMessage.lookup(epsiStateMessages, state);

  switch (state) {
    case EPSI_STATE.IMPORTED: {
      return <SuccessBadge>{stateText}</SuccessBadge>;
    }
    case EPSI_STATE.WAITING_FOR_DOWNLOAD: {
      return <InfoBadge>{stateText}</InfoBadge>;
    }
    case EPSI_STATE.WAITING_FOR_IMPORT:
    case EPSI_STATE.DOWNLOADING:
    case EPSI_STATE.IMPORTING: {
      return (
        <Badge unsafeClassName='dmx-badge--in-progress'>
          <div className='sg-a-d-f sg-a-ai-c'>
            <Icon element={<SvgSpinner />} />
            <span className='sg-a-ml-1/2 sg-a-ws-nw'>{stateText}</span>
          </div>
        </Badge>
      );
    }
    case EPSI_STATE.DOWNLOAD_FAILED:
    case EPSI_STATE.IMPORT_FAILED: {
      return <DangerBadge>{stateText}</DangerBadge>;
    }
    default: {
      console.warn(`[EpsiBadge]: Unknown epsi state (${state})`);
      return state;
    }
  }
};
